export default __webpack_public_path__ + "static/media/edit_avatar_button.28c76528.svg";